(function () {
  'use strict';

  var config = window.CSCartRedirectConfig;
  if (!config || !config.drawerEnabled) return;

  function createSignal() {
    return {
      version: config.version,
      timestamp: Date.now()
    };
  }

  function isValidSignal(signal) {
    if (!signal || signal.version !== config.version || !Number.isFinite(signal.timestamp)) return false;

    var age = Date.now() - signal.timestamp;
    return age >= 0 && age <= config.ttlMilliseconds;
  }

  function fallbackValue(signal) {
    return String(signal.version) + '.' + String(signal.timestamp);
  }

  function parseFallbackValue(value) {
    if (!value) return null;

    var parts = value.split('.');
    if (parts.length !== 2) return null;

    return {
      version: Number(parts[0]),
      timestamp: Number(parts[1])
    };
  }

  function redirectFromCart() {
    var signal = createSignal();
    var destination = new URL(config.rootUrl, window.location.origin);

    try {
      window.sessionStorage.setItem(config.signalKey, JSON.stringify(signal));
    } catch (error) {
      destination.searchParams.set(config.fallbackParameter, fallbackValue(signal));
    }

    window.location.replace(destination.pathname + destination.search + destination.hash);
  }

  function consumeStoredSignal() {
    var stored = null;

    try {
      stored = window.sessionStorage.getItem(config.signalKey);
      window.sessionStorage.removeItem(config.signalKey);
    } catch (error) {
      return null;
    }

    if (!stored) return null;

    try {
      return JSON.parse(stored);
    } catch (error) {
      return null;
    }
  }

  function consumeFallbackSignal() {
    var currentUrl = new URL(window.location.href);
    var value = currentUrl.searchParams.get(config.fallbackParameter);
    if (!value) return null;

    currentUrl.searchParams.delete(config.fallbackParameter);
    window.history.replaceState({}, '', currentUrl.pathname + currentUrl.search + currentUrl.hash);
    return parseFallbackValue(value);
  }

  function requestNativeDrawerOpen() {
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return;

    window.customElements.whenDefined('cart-drawer').then(function () {
      var drawer = document.getElementById('CartDrawer');
      if (drawer) drawer.isOpen = true;
    });
  }

  function consumeOnRoot() {
    var storedSignal = consumeStoredSignal();
    var fallbackSignal = consumeFallbackSignal();
    var signal = isValidSignal(storedSignal) ? storedSignal : fallbackSignal;

    if (!isValidSignal(signal)) return;
    requestNativeDrawerOpen();
  }

  if (config.isCartTemplate) {
    redirectFromCart();
    return;
  }

  if (config.isRootTemplate) consumeOnRoot();
})();
